import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, Teleport as _Teleport, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row-menu" }
const _hoisted_2 = { class: "row-menu__transaction-button-text" }
const _hoisted_3 = ["id"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "row-menu__dropdown-option-text" }

import SvgLoader from '@/utils/SvgLoader.vue';
import TextButton from '@/components/input/Btn/TextButton.vue';
import { computed, ref, StyleValue } from 'vue';
import { getRandomStr } from '@/businessRepository/idUtils';
import { i18n } from '@/i18n';

/** Emits */

export default /*@__PURE__*/_defineComponent({
  __name: 'ForecastForReceiptRowMenu',
  emits: ["onClickTransactionList", "onSelectMenu"],
  setup(__props, { emit: __emit }) {

const emits = __emit;

/** Variables */
const t = i18n.t;
const containerId = getRandomStr(16);
const isMenuOpenedState = ref<boolean>(false);
const menuButtonPosition = ref({
  x: 0,
  y: 0,
});

/** Menu items */
const MENU_ITEMS = [
  {
    value: 'download' as const,
    icon: 'downloadSmall',
    text: 'ダウンロード',
  },
  /*{
    value: 'forecastRequestMail' as const,
    icon: 'mailIcon',
    text: '内示依頼メール',
  },*/
  {
    value: 'edit' as const,
    icon: 'editPen',
    text: '編集',
  },
];

/** Function */
const onClickButton = () => {
  if (!isMenuOpenedState.value) {
    const buttonContent = document.getElementById(containerId);
    const bodyContent = document.getElementsByTagName('body')[0];
    if (!(buttonContent instanceof HTMLElement) || !(bodyContent instanceof HTMLElement)) return;
    menuButtonPosition.value = {
      x: buttonContent.offsetWidth,
      y: buttonContent.getBoundingClientRect().top,
    };
  }
  isMenuOpenedState.value = !isMenuOpenedState.value;
};

const dropdownMenuStyle = computed((): StyleValue => {
  return {
    top: `${menuButtonPosition.value.y + 20}px`,
    right: `${menuButtonPosition.value.x}px`,
  };
});

/**
 * メニューの選択肢を選んだ際の処理
 * @param value - 選択した値
 */
const selectOption = (value: (typeof MENU_ITEMS)[number]['value']) => {
  isMenuOpenedState.value = false;
  emits('onSelectMenu', value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(TextButton, {
        class: "row-menu__transaction-button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('onClickTransactionList')))
      }, {
        default: _withCtx(() => [
          _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(t)('取引一覧')), 1)
        ], undefined, true),
        _: 1
      }),
      _createElementVNode("div", {
        id: _unref(containerId),
        class: "row-menu__ellipsis-container"
      }, [
        _createElementVNode("button", {
          class: _normalizeClass(["row-menu__ellipsis-button", { 'row-menu__ellipsis-button--active': isMenuOpenedState.value }]),
          onClick: onClickButton
        }, [
          _createVNode(SvgLoader, {
            class: "row-menu__ellipsis-icon",
            name: "menuEllipsis"
          })
        ], 2)
      ], 8, _hoisted_3)
    ]),
    (isMenuOpenedState.value)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 0,
          to: "body"
        }, [
          _createElementVNode("div", {
            class: "row-menu__bg",
            onClick: onClickButton
          }),
          _createElementVNode("div", {
            class: "row-menu__dropdown",
            style: _normalizeStyle(dropdownMenuStyle.value)
          }, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(MENU_ITEMS, (option) => {
              return _createElementVNode("div", {
                key: option.value,
                class: "row-menu__dropdown-content"
              }, [
                _createElementVNode("button", {
                  class: "row-menu__dropdown-option row-menu__dropdown-option--active",
                  onClick: ($event: any) => (selectOption(option.value))
                }, [
                  _createVNode(SvgLoader, {
                    class: "row-menu__dropdown-icon",
                    name: option.icon
                  }, null, 8, ["name"]),
                  _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)(option.text)), 1)
                ], 8, _hoisted_4)
              ])
            }), 64))
          ], 4)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})